import { themes } from '~/themes/index'

export const getPrimaryColor = () => {
  const runtimeConfig = useRuntimeConfig();
  const themeKey = runtimeConfig.public.apppUiTheme;
  const uiConfig = themes[themeKey];
  const primaryValue = uiConfig?.appConfig?.ui?.primary;
  return (
    uiConfig?.tailwindConfig?.extend?.colors?.[primaryValue]?.[500] ||
    '#0C5542'
  );
}